import React from "react";
import styles from "./section_get_started.module.scss";

export const SectionGetStarted = () => {
  return (
    <section className={styles.section_get_started}>
      <div className="container">test</div>
    </section>
  );
};

export default SectionGetStarted;
